import { render, staticRenderFns } from "./InstalledApps.vue?vue&type=template&id=70913c00"
import script from "./InstalledApps.vue?vue&type=script&lang=js"
export * from "./InstalledApps.vue?vue&type=script&lang=js"
import style0 from "./InstalledApps.vue?vue&type=style&index=0&id=70913c00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports